import { postProtected } from './utils';

/**
 * @typedef PaymentModel
 * @type {object}
 * @property {number} Amount
 * @property {string} BonusCode
 * @property {string} SuccessUrl
 * @property {string} ErrorUrl
 * @property {string} PendingUrl
 * @property {string} BackUrl
 */

/**
 * @typedef PaymentResponse
 * @type {object}
 * @property {string} GetUrl
 * @property {string} Url
 * @property {object} Parameters
 * @property {string} FormHTML
 */

/**
 * Initiate a safe charge deposit
 * @param {string} playerSessionID 
 * @param {PaymentModel} paymentModel 
 * @returns {PaymentResponse}
 */
export var initSafeCharge = function initSafeCharge(playerSessionID, paymentModel) {
  return postProtected('/payments/safecharge', playerSessionID, paymentModel);
};

export default {
  initSafeCharge: initSafeCharge
};